import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b804aa7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-items" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("NOW PLAYING")
const _hoisted_3 = { class: "menu-item toggle-menu" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, "Gêneros", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-caret-down icon-desktop" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bars icon-mobile" }, null, -1))
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "search-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" })
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { type: "submit" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        class: "app-name",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("nav", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }, _hoisted_7),
          (_ctx.showMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "menu-overlay",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["self"]))
              }, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", _hoisted_8, [
                    _createElementVNode("form", {
                      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
                      class: "search-form-mobile"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event))
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.searchTerm,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _hoisted_9
                    ], 32)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genres, (genre) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: genre.id,
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
                    }, [
                      _createVNode(_component_router_link, {
                        to: `/genre/${genre.id}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(genre.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
      class: "search-form"
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "search",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchTerm) = $event))
      }, null, 512), [
        [
          _vModelText,
          _ctx.searchTerm,
          void 0,
          { trim: true }
        ]
      ]),
      _hoisted_10
    ], 32)
  ]))
}